export const fileSize = (bytes, si) => {
  let fileBytes = bytes;
  const thresh = si ? 1000 : 1024;
  if (Math.abs(fileBytes) < thresh) {
    return `${fileBytes} B`;
  }
  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  do {
    fileBytes /= thresh;
    u += 1;
  } while (Math.abs(fileBytes) >= thresh && u < units.length - 1);
  return `${fileBytes.toFixed(1)} ${units[u]}`;
};

export default fileSize;



// WEBPACK FOOTER //
// ./src/filters/number.js